namespace $.$$ {

	export class $shm_hitalama_map_widget_float_code_html_bench extends $.$shm_hitalama_map_widget_float_code_html_bench {

		external_view_widget() {
			const view_widget = this.widget().view_widget()
			if( view_widget?.removed() ) return null
			return view_widget
		}

		result_visible() {
			if( this.external_view_widget() ) return []
			return super.result_visible()
		}

	}

}
